import { render, staticRenderFns } from "./DriverAndPassengerCard.vue?vue&type=template&id=782c1cb0&"
import script from "./DriverAndPassengerCard.vue?vue&type=script&lang=js&"
export * from "./DriverAndPassengerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('782c1cb0')) {
      api.createRecord('782c1cb0', component.options)
    } else {
      api.reload('782c1cb0', component.options)
    }
    module.hot.accept("./DriverAndPassengerCard.vue?vue&type=template&id=782c1cb0&", function () {
      api.rerender('782c1cb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/transports/components/DriverAndPassengerCard.vue"
export default component.exports